<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputMac" placeholder="请输入did" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
				<el-date-picker v-model="Time" size="small" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    			</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="BeforeFind" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99%;" align="center" :max-height="maxHeight">
		    <el-table-column prop="did" label="DID" width="140" fixed></el-table-column>
		    <el-table-column prop="e1" label="版本标注" :formatter="e1Format"></el-table-column>
		    <el-table-column prop="e2" label="软件版本" :formatter="e2Format"></el-table-column>
		    <el-table-column prop="e3" label="系统时间戳" width="160" :formatter="dateFormat"></el-table-column>
		    <el-table-column label="驱动器故障" width="95">
		    	<el-table-column v-for="(item,index) in driveErrlist" :label='item' :key="item.index" width="100">
			    	<template slot-scope="scope">
			    		<span v-if="scope.row.e4[index] == '是'" style="color: red;">{{scope.row.e4[index]}}</span>
			    		<span v-if="scope.row.e4[index] == '否'">{{scope.row.e4[index]}}</span>
				    </template>
		    	</el-table-column>
		    </el-table-column>
		    <el-table-column label="外设故障">
		    	<el-table-column v-for="(item,index) in statelist" :label='item.cn' :key="item.index" width="100">
			    	<template slot-scope="scope">
			    		<span v-if="scope.row.e5[index] == '是'" style="color: red;">{{scope.row.e5[index]}}</span>
			    		<span v-if="scope.row.e5[index] == '否'">{{scope.row.e5[index]}}</span>
				    </template>
		    	</el-table-column>
		    </el-table-column>
		    <el-table-column prop="e6" label="SOS触发">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.e6 == '1'" style="color: red;">是</span>
			    	<span v-if="scope.row.e6 != '1'">否</span>
					</template>
		    </el-table-column>
		    <el-table-column label="按键失效故障">
		    	<el-table-column v-for="(item,index) in BtnErrlist" :label='item' :key="item.index" width="100">
			    	<template slot-scope="scope">
			    		<span v-if="scope.row.e7[index] == '是'" style="color: red;">{{scope.row.e7[index]}}</span>
			    		<span v-if="scope.row.e7[index] == '否'">{{scope.row.e7[index]}}</span>
				    </template>
		    	</el-table-column>
		    </el-table-column>
		    	
		    	
		    	<!--<el-table-column v-for="(item,index) in motorlist" :label='item.cn' :key="item.index" width="100">
			    	<el-table-column v-for="(item,index) in errlist" :label='item' :key="item.index" width="100">
				    	<template slot-scope="scope">
				    		<span v-if="scope.row.e8[index] == '故障'" style="color: red;">{{scope.row.e8[index]}}</span>
			    			<span v-if="scope.row.e8[index] == '正常'">{{scope.row.e8[index]}}</span>
					    </template>
		    		</el-table-column>
		    	</el-table-column>-->
		    	
		    	<el-table-column label='座椅电位器断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="scope.row.e8 & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	
		    	<el-table-column label='座椅电机断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 1) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	
		    	<el-table-column label='座椅电位器损坏' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 3) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	
		    	<el-table-column label='缠绕带电位器断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 5) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='缠绕带电机断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 6) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='缠绕带电位器损坏' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 8) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='摆臂推杆电机过流' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 10) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='摆臂推杆电机断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 16) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	
		    	<el-table-column label='上层升降电机过流' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 17) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='上层升降电机断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 23) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='脚踏电机过流' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 24) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='脚踏电机电位器断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 29) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    	<el-table-column label='脚踏电机断线' width="100">
		    		<template slot-scope="scope">
				    	<span v-if="(scope.row.e8 >> 30) & 1 == 1" style="color: red;">故障</span>
			    		<span v-else>正常</span>
					</template>
		    	</el-table-column>
		    		
		    <el-table-column prop="time" label="时间" fixed="right" width="170" :formatter="dateFormat"></el-table-column>
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
	</div>
</template>

<script>
	import {GetDevWheelChairErrlist} from '../api/api';
	
	export default {
		data(){
			return{
				maxHeight:600,
				token:"",
				inputMac:"",
				timer:"",
				Time:[],
				List:[],
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				statelist:[
					{cn:"继电器坏"},
					{cn:"蓝牙断开"},
					{cn:"设备丢失"},
					{cn:"摇杆断"},
					{cn:"超声传感器故障"},
					{cn:"Flash异常"},
					{cn:"激光传感器故障"}
				],
//				motorlist:[
//					{cn:"轮毂电机"},
//					{cn:"缠绕带电机"},
//					{cn:"座椅电机"},
//					{cn:"升降电机"},
//					{cn:"推杆电机"},
//					{cn:"脚踏电机"},
//				],
				errlist:[
					"电机断线",
					"电机过流",
					"电位器断线",
					"运动与电位器运动关系出错"
				],
				driveErrlist:[
					"左霍尔故障",
					"右霍尔故障",
					"电池故障",
					"左侧马达故障",
					"右侧马达故障",
					"左侧刹车故障",
					"右侧刹车故障",
					"控制器故障",
					"通讯错误",
					"上电摇杆不在零位",
					"左电机堵转过流",
					"右电机堵转过流",
					"断线"
				],
				BtnErrlist:[
					"锁定按键",
					"缠绕带in按键",
					"缠绕带out按键",
					"座椅up按键",
					"座椅down按键",
					"速度按键",
					"SOS按键"
				]
			}
		},
		beforeRouteLeave(to,from,next){
        	clearInterval(this.timer)
        	next()
        },
		methods:{
			e1Format(row,column){
				if(row[column.property]){
					let d1 = row[column.property]
					if(d1 == "1"){return "运动版"}
//					else if(d1 == "2"){return "医用版"}
//					else if(d1 == "3"){return "老年版"}
//					else if(d1 == "4"){return "智能版"}
					else {return row[column.property]}
				}else{
					return "无"
				}
			},
			e2Format(row,column){
				if(row[column.property]){
					let bb = row[column.property] + ""
					return "v" + bb.substring(0,1) + "." + bb.substring(1)
				}else{
					return "无"
				}
			},
			BeforeFind(){
				this.Curpage = 1
				this.Find()
			},
			Find(){
				if(this.Time){
					this.Betweenall = {"BETWEEN":{'time':[this.Time[0]/1000,this.Time[1]/1000]}}
				}else{
					this.Betweenall = {"BETWEEN":{}}
				}
				if(this.inputMac){
					this.Screenall = {"AND":{'did':'~' + this.inputMac}}
				}else{
					this.Screenall = {"AND":{}}
				}
				var ever = [this.Screenall,this.Betweenall]
				var ever2 = JSON.stringify(ever)
				if(this.Screenall || this.Betweenall){
					this.GetSportErrList(GetDevWheelChairErrlist,{page:this.Curpage,token:this.token,sort:"-time",q:ever2})
				}else{
					this.GetSportErrList(GetDevWheelChairErrlist,{page:this.Curpage,token:this.token,sort:"-time"})
				}
			},
			Inloop(){
				this.Find()
			},
			Loop(){
				this.timer = setInterval(() => {this.Inloop()},30000)
			},
			Refresh(){
				this.Time = ""
				this.inputMac = ""
				this.Curpage = 1
				this.GetSportErrList(GetDevWheelChairErrlist,{page:this.Curpage,token:this.token,sort:"-time"})
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Find()
			},
			GetSportErrList(way,param){
		   		var that = this
		   		var list = []
		   		
		   		that.listloading = true
				way(param).then(res => {
					console.log('res',res)
					console.log("这是通用函数")
					list = res.data.items
//					that.List = res.data.items
					
					that.Pagesize = res.data.meta.perPage
					that.total = res.data.meta.totalCount
					
					for(var a=0;a<list.length;a++){
						var arr0 = []
						for(var i=0;i<13;i++){
							arr0.push((list[a].e4 >> i & 1) == 0 ? "否":"是")
						}
						list[a].e4 = arr0
					}
					
					
					
					for(var i=0;i<list.length;i++){
						var arr = []
						for(var j=0;j<7;j++){
							arr.push((list[i].e5 >> j & 1) == 0 ? "否":"是")
						}
						list[i].e5 = arr
					}
					
					for(var i=0;i<list.length;i++){
						var arr = []
						for(var j=0;j<7;j++){
							arr.push((list[i].e7 >> j & 1) == 0 ? "否":"是")
						}
						list[i].e7 = arr
					}
					
//					for(var m=0;m<list.length;m++){
//						var arr2 = []
//						var B,C
//						for(var i=0;i<6;i++){
//							B = 0b00001111 & list[m].e8 << i*4
//							for(var j=0;j<4;j++){
//								C = B & (0b0001 << i)
//								arr2.push(C == 0 ? "正常":"故障")
//							}
//						}
//						list[m].e8 = arr2
//					}
					that.List = list
					that.listloading = false


					console.log('lbf200728',that.List)

				}).catch(err => {
					console.log(err.response.data.message)
					that.$message.error(err.response.data.message)
					that.List = []
					that.listloading = false
				})
		   }
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetSportErrList(GetDevWheelChairErrlist,{page:this.Curpage,token:this.token,sort:"-time"})
			this.Loop()
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// WheelChairErr.vue?7af0adc5